import { api } from "./base";
/**
 * Шаринг («Поделиться песней»): владелец готового трека собирает публичную
 * страницу-подарок поверх аудио и делится ссылкой. Публичное чтение по токену
 * — без авторизации. Контракт: см. `frontend_sharing_and_modes`.
 *
 * Базовые пути:
 *  - владелец (auth обязателен): /api/v1/public/shares
 *  - публичное чтение:            /api/v1/public/shares/by-token/{token}
 *  - каталог пресетов:            /api/v1/public/share-presets
 */
const SHARES_BASE = "/api/v1/public/shares";
const SHARE_PRESETS_URL = "/api/v1/public/share-presets";
/** Создать шару поверх своего готового аудио → 201. */
export const createShare = async (payload) => {
    const response = await api.post(SHARES_BASE, payload);
    return response.data;
};
/** Список своих шар. */
export const listShares = async () => {
    const response = await api.get(SHARES_BASE);
    return response.data;
};
/** Своя шара по id (владелец, иначе 404). */
export const getShare = async (shareId) => {
    const response = await api.get(`${SHARES_BASE}/${shareId}`);
    return response.data;
};
/**
 * Обновить config своей шары. Тело — ПОЛНЫЙ config (не partial-merge),
 * тип шары не меняется, валидация под существующий type.
 */
export const updateShare = async (shareId, config) => {
    const response = await api.patch(`${SHARES_BASE}/${shareId}`, {
        config,
    });
    return response.data;
};
/** Удалить свою шару → 204. */
export const deleteShare = async (shareId) => {
    await api.delete(`${SHARES_BASE}/${shareId}`);
};
/**
 * Загрузить одно фото шары (multipart, поле `file`). Каждая загрузка добавляет
 * один URL в `config.photos` (суммарно ≤ 20). Content-Type снимаем (undefined),
 * чтобы браузер сам выставил multipart-boundary.
 */
export const uploadSharePhoto = async (shareId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post(`${SHARES_BASE}/${shareId}/photos`, formData, { headers: { "Content-Type": undefined } });
    return response.data;
};
/**
 * Публичный каталог пресетов (без auth). Возвращаются только активные
 * (`is_active=true`), упорядоченные по `order`. platform — опциональный фильтр.
 */
export const getSharePresets = async (platform) => {
    const response = await api.get(SHARE_PRESETS_URL, {
        params: platform ? { platform } : undefined,
    });
    return response.data;
};
/**
 * Публичное чтение шары по токену (без auth). Путь — `/shares/by-token/{token}`
 * (НЕ `/shares/{token}` — тот owner-роут по int id). 404 — не найдена/аудио удалено.
 */
export const getPublicShareByToken = async (token) => {
    const response = await api.get(`${SHARES_BASE}/by-token/${encodeURIComponent(token)}`);
    return response.data;
};
/**
 * Прямая (presigned) ссылка на скачивание аудио шары по токену (без auth). Бэк
 * отдаёт `{ url }` на объект в хранилище с `Content-Disposition: attachment` —
 * файл качается напрямую, без стрима через бэк. Зеркало
 * `getPublicSongDownloadUrl` (см. `api/songs.ts`), но по токену шары: качается
 * ровно то аудио, на которое указывает шара (полный трек или минус —
 * `use_instrumental`).
 *
 * Возвращает `undefined`, если бэк не отдал url — вызывающий код обязан иметь
 * фолбэк (прямая ссылка на трек). `timeoutMs` перебивает общие 85 с инстанса
 * `api`: за кнопкой скачивания крутится спиннер, и полторы минуты молчания
 * выглядят как зависание.
 */
export const getPublicShareDownloadUrl = async (token, timeoutMs) => {
    const response = await api.get(`${SHARES_BASE}/by-token/${encodeURIComponent(token)}/download-url`, timeoutMs != null ? { timeout: timeoutMs } : undefined);
    return response.data?.url;
};
